import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { startRegistration } from "../../redux/UserAPI";
import { RootState } from "../../redux/store";
import { IDOB } from "../../interfaces";

export interface IRegistrationSlice {
  termsCond: boolean;
  emailConfirm: boolean;
  consent: boolean;
  checkbox1: boolean;
  checkbox2: boolean;
  checkbox3: boolean;
  regNum: number |null | "";
  email: string | undefined;
  dob: IDOB;
}

export const RegistrationState: IRegistrationSlice = {
  consent: false,
  termsCond: false,
  emailConfirm: false,
  checkbox1: false,
  checkbox2: false,
  checkbox3: false,
  regNum: '',
  email: '',
  dob: { year: 1900, month: 0, date: 1 },
};

export const registrationSlice = createSlice({
  name: "registration",
  initialState: RegistrationState,
  reducers: {
    setConsent: (state, action: PayloadAction<boolean>) => {
      state.consent = action.payload;
    },
    setTermsCond: (state, action: PayloadAction<boolean>) => {
      state.termsCond = action.payload;
    },
    setCheckbox1: (state, action: PayloadAction<boolean>) => {
      state.checkbox1 = action.payload;
    },
    setCheckbox2: (state, action: PayloadAction<boolean>) => {
      state.checkbox2 = action.payload;
    },
    setCheckbox3: (state, action: PayloadAction<boolean>) => {
      state.checkbox3 = action.payload;
    },

    setEmail: (state, action: PayloadAction<string | undefined>) => {
      state.email = action.payload;
    },
    setEmailConfirm: (state, action: PayloadAction<boolean>) => {
      state.emailConfirm = action.payload;
    },
    setRegNum: (state, action: PayloadAction<number | null>) => {
      state.regNum = action.payload;
    },
    setDob: (state, action: PayloadAction<IDOB>) => {
      state.dob = action.payload;
    },
    reset: (state) => {
      state.consent= false;
      state.termsCond= false;
      state.emailConfirm= false;
      state.checkbox1= false;
      state.checkbox2= false;
      state.checkbox3= false;
      state.regNum= '';
      state.email= '';
      state.dob = { year: 1900, month: 0, date: 1 }
  }
}

});

export const { setConsent, setTermsCond, setCheckbox1, setCheckbox2, setCheckbox3, setEmail, setRegNum, setDob, setEmailConfirm, reset } =
  registrationSlice.actions;

export const selectConsent = (state: RootState) => state.registration.consent;
export const selectTerms = (state: RootState) => state.registration.termsCond;
export const selectCheckbox1 = (state: RootState) => state.registration.checkbox1;
export const selectCheckbox2 = (state: RootState) => state.registration.checkbox2;
export const selectCheckbox3 = (state: RootState) => state.registration.checkbox3;
export const selectEmail = (state: RootState) => state.registration.email;
export const selectRegNum = (state: RootState) => state.registration.regNum;
export const selectDob = (state: RootState) => state.registration.dob;
export const selectEmailConfirm = (state: RootState) => state.registration.emailConfirm;


export default registrationSlice.reducer;